import script from "./SimplePagination.vue?vue&type=script&lang=ts&setup=true"
export * from "./SimplePagination.vue?vue&type=script&lang=ts&setup=true"

import "./SimplePagination.vue?vue&type=style&index=0&id=5089ee20&scoped=true&lang=scss"

import exportComponent from "/github/workspace/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5089ee20"]])

export default __exports__